export enum ErrorType {
  Conflict,
  Navigation,
  Validation,
  NotFound,
  Firewall,
  NotAllowed,
  // A file upload refused by a proxy on the customer's own network; the error carries the message to show.
  ProxyBlock
}
export class ErrorObject {
  uuid: any;
  details: any[];
  errorType: ErrorType;

  safariApiError: boolean;
  message: string;
  jsStack: string;
  developerException: any;
  pageContext?: any;
  maxValidationErrors?: number;
  originalError: any; // Most likely httperrorresponse or string, but really could be anything JS wants it to be
}
